import React from "react";
import axios from "axios";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import theme from "./theme/theme";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import store from "./redux/store";
import { signOut } from "./redux/user/userActions";
import { showAlert } from "./redux/alert/alertActions";

import "./sass/main.scss";

// Global axios interceptor: auto sign-out on 401/403
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      try { store.dispatch(signOut()); } catch (_) {}
    }
    return Promise.reject(error);
  }
);

// On boot, clear expired JWT in localStorage
(() => {
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    const parts = token.replace('Bearer ', '').split('.');
    if (parts.length === 3) {
      const payload = JSON.parse(atob(parts[1]));
      const exp = payload?.exp; // seconds since epoch
      if (typeof exp === 'number' && Date.now() / 1000 > exp) {
        store.dispatch(signOut());
      }
    }
  } catch (_) {
    // if token is malformed, sign out
    try { store.dispatch(signOut()); } catch (_) {}
  }
})();

if (process.env.NODE_ENV === "development") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React);
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Resets default browser styles */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);

// const rootElement = document.getElementById('root');
// const root = ReactDOM.createRoot(rootElement);

// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </Provider>
//   </React.StrictMode>
// );

serviceWorker.register({
  onUpdate: () => {
    store.dispatch(
      showAlert("An update is ready. Close and reopen the app to load the latest version.")
    );
  },
});

window.addEventListener("beforeinstallprompt", (event) => {
  if (!isMobileDevice()) {
    return;
  }
  event.preventDefault();
  window.__tusDeferredInstallPrompt = event;
  store.dispatch(
    showAlert("Get the best experience: add Team Up Sports to your home screen from your browser menu.")
  );
});

window.requestTUSPwaInstall = async () => {
  if (!isMobileDevice()) {
    return false;
  }
  if (!window.__tusDeferredInstallPrompt) {
    return false;
  }
  const promptEvent = window.__tusDeferredInstallPrompt;
  promptEvent.prompt();
  const choiceResult = await promptEvent.userChoice;
  window.__tusDeferredInstallPrompt = null;
  if (choiceResult.outcome === "accepted") {
    store.dispatch(showAlert("Great! Team Up Sports is installing on your device."));
  }
  return choiceResult.outcome === "accepted";
};
const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false;
  if (navigator.userAgentData && typeof navigator.userAgentData.mobile === "boolean") {
    return navigator.userAgentData.mobile;
  }
  const ua = navigator.userAgent || navigator.vendor || window.opera || "";
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  return isIOS || isAndroid;
};
